import { EColor } from 'common/const';
import { IOption } from 'common/models';
import { isMatchedBySearch, mapToMenuWithDivider } from 'common/helpers';
import { EUserRole } from 'entities/User/User.enum';
import { IUser, IUserAssignee } from 'entities/User/User.models';

export const getUserName = {
  initials: (lastName?: string, firstName?: string) => {
    return `${firstName ? firstName[0] : ''}${lastName ? lastName[0] : ''}`;
  },
  fullName: (lastName?: string, firstName?: string, patronymic?: string) => {
    return `${lastName ? lastName : ''} ${firstName ? firstName : ''} ${patronymic ? patronymic : ''}`.trim();
  },
  fullLastNameAndInitials: (lastName?: string, firstName?: string, patronymic?: string) => {
    // eslint-disable-next-line sonarjs/no-nested-template-literals
    return `${lastName ? lastName : ''} ${firstName ? `${firstName.slice(0, 1)}.` : ''}${
      patronymic ? `${patronymic.slice(0, 1)}.` : ''
    }`.trim();
  },
};

export const getUserRole = (roles?: string[]) => {
  return {
    isSuperAdmin: !!roles?.includes(EUserRole.SuperAdmin),
    isAccountAdmin: !!roles?.includes(EUserRole.AccountAdmin),
    isSellerManager: !!roles?.includes(EUserRole.SellerManager),
    isManager: !!roles?.includes(EUserRole.Manager),
    isHeadOfDepartment: !!roles?.includes(EUserRole.HeadOfDepartment),
    isUser:
      !roles?.includes(EUserRole.SuperAdmin) &&
      !roles?.includes(EUserRole.AccountAdmin) &&
      !roles?.includes(EUserRole.SellerManager) &&
      !roles?.includes(EUserRole.Manager) &&
      !roles?.includes(EUserRole.HeadOfDepartment),
  };
};

export const getUserRoleChipColor = (role: string) => {
  switch (role) {
    case EUserRole.AccountAdmin: {
      return EColor.PalePurple;
    }
    case EUserRole.Manager: {
      return EColor.PaleGreen;
    }
    case EUserRole.SellerManager:
    case EUserRole.HeadOfDepartment: {
      return EColor.PaleBlue;
    }
    default: {
      return EColor.LightGrey;
    }
  }
};

export const getUserOptions = (list: IUser[]) => {
  return list
    .map((user) => ({ label: getUserName.fullName(user.lastName, user.firstName, user.patronymic), value: user.id }))
    .sort((a, b) => a.label.localeCompare(b.label));
};

export const getUserKey = (id: number, name: string): string => {
  return `${id}_${name.replace(/\s/g, '_')}`;
};

export const calculateUserBalance = (user: IUser | null) => {
  return user?.limit ? user.limit - user.spentLimit : null;
};

export const getUserAssigneeOptions = (users: IUser[], assignees: IUserAssignee[], search: string): IOption[] => {
  const userOptions = users.map((item) => {
    const name = getUserName.fullName(item.firstName, item.lastName, item.patronymic);
    return { label: name, value: getUserKey(item.id, name), extra: false };
  });
  const assigneeOptions = assignees.map((item) => ({ label: item.name, value: getUserKey(item.id, item.name), extra: true }));
  const matchesBySearch = userOptions
    .concat(assigneeOptions)
    .filter((item) => isMatchedBySearch(item.label, search))
    .sort((a, b) => a.label.localeCompare(b.label));

  return mapToMenuWithDivider(matchesBySearch);
};
